<i-feather [class]="class" [name]="icon!"></i-feather>
